import React, { useEffect, useState } from 'react';
import { Container, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import { Logo, Navbar, SocialLinks } from '.';

/**
 * Header component for the homepage.
 * Applies sticky behavior and updates metadata dynamically from localStorage settings.
 *
 * @returns {JSX.Element}
 */
const Header = () => {
	const [isSticky, setIsSticky] = useState(false);
	const settings = getSettings();

	/**
	 * Reads site settings from localStorage.
	 *
	 * @returns {Object|null}
	 */
	function getSettings() {
		try {
			const storedSettings = localStorage.getItem('settings');
			return storedSettings ? JSON.parse(storedSettings) : null;
		} catch (error) {
			console.error('Failed to parse settings from localStorage:', error);
			return null;
		}
	}

	/**
	 * Toggles sticky class on scroll.
	 */
	const handleScroll = () => {
		setIsSticky(window.scrollY > 180);
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll, { passive: true });

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const pageTitle = settings ? `${settings.site_name} | ${settings.description}` : 'Jinesh P.V';
	const pageDescription = settings?.description || 'Architect | Fullstack Developer | React | Docker | Kubernetes';

	return (
		<>
		<Helmet>
			<title>{pageTitle}</title>
			<meta name="description" content={pageDescription} />
			<meta
			name="robots"
			content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
			/>
			<link rel="canonical" href="https://jineshpv.com/" />
		</Helmet>

		<header id="header" className="sticky-top-slide">
			<nav
			className={`primary-menu navbar navbar-expand-lg text-uppercase navbar-line-under-text fw-600 ${
				isSticky ? 'sticky-on' : ''
			}`}
			>
			<Container className="position-relative">
				<Col className="col-auto col-lg-2 d-inline-flex ps-lg-0">
					<Logo />
				</Col>
				<Col className="col-lg-7 navbar-accordion px-0">
					<Navbar />
				</Col>
				<Col className="col-auto col-lg-3 d-flex justify-content-end ps-0">
					<SocialLinks />
				</Col>
			</Container>
			</nav>
		</header>
		</>
	);
};

export default Header;
